/**
 * Stage 5B seed data for the per-language "Activities" list and the flat
 * "Exhibitor categories" list, used when the DB has no stored value yet so the
 * superadmin edits from the current legacy content rather than a blank slate.
 *
 * Activities are language-dependent. EN/FR come from bf-2026_conf.inc.php; DE is
 * the existing German set from workshopfrance2024_conf.inc.php (stored there
 * under the mislabeled $_activities_en variable). Indices are aligned across
 * languages: row N is the same option in every language.
 *
 * Exhibitor categories are a single, language-neutral list (legacy
 * $_EVENT_EXIBITOR_CATEGORIES): the strings double as stored keys, so they are
 * NOT translated.
 */
export const ACTIVITY_DEFAULTS: { [lang: string]: string[] } = {
  en: [
    'Accomodation',
    'Barging',
    'Carriers',
    'Cultural Sites',
    'Excursions / Entertainment',
    'Incoming services',
    'Leisure or entertainment park',
    'Restaurant',
    'Ski',
    'Tourist office',
    'Other',
    'Shopping',
    'Luxury offers',
    'MICE Services',
  ],
  fr: [
    'Hébergement',
    'Location fluviale',
    'Transporteur',
    'Sites culturels',
    'Excursion, guide',
    'Agence réceptive',
    "Parc d'attraction ou de loisirs",
    'Restaurant',
    'Ski',
    'Office du Tourisme',
    'Autre',
    'Shopping',
    'Luxury offers',
    'MICE Services',
  ],
  de: [
    'Unterkunft',
    'Bootsverleiher',
    'Transporteur',
    'Kulturelle Stätten',
    'Exkursionen / Führungen',
    'Incomingagentur',
    'Freizeitpark',
    'Restaurant',
    'Ski',
    'Tourismusbüro',
    'Andere',
    'Shopping',
    'Luxusangebote',
    'MICE Services',
  ],
};

export const CATEGORY_DEFAULTS: string[] = [
  'Accommodation',
  'Boating Holidays',
  'Carriers',
  'Cultural Sites',
  'Excursions / Entertainment',
  'Incoming services',
  'Luxury offers',
  'MICE Services',
  'Ski',
  'Tourist offices',
  'Shopping',
  'Cruises',
  'Wine Tourism',
  'Others',
];
